'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 732 603.793",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3f3d56",
    d: "M58.945 354.474h144.26v134.953H58.945z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M262.15 536.35H0V307.551h262.15ZM1.55 534.8h259.047V309.101H1.551ZM621.575 220.85A110.425 110.425 0 1 1 732 110.425 110.55 110.55 0 0 1 621.575 220.85Zm0-219.214a108.79 108.79 0 1 0 108.79 108.79 108.912 108.912 0 0 0-108.79-108.79Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 618.303,
    cy: 110.425,
    r: 53.168,
    fill: "#3f3d56"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ff6584",
    d: "m675.334 289.878 31.583-18.234 18.234 31.583-31.583 18.234z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#3f3d56",
    d: "m193.334 112.878 31.583-18.234 18.234 31.583-31.583 18.234z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#e5e5e5",
    d: "m631.334 488.878 31.583-18.234 18.234 31.583-31.583 18.234z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1495f3",
    d: "M117.89 408.766h26.37v26.37h-26.37z"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 618.303,
    cy: 110.425,
    r: 13.087,
    fill: "#1495f3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1495f3",
    d: "m505.811 327.236 67.748-39.114 39.114 67.747-67.748 39.114z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#cbcbcb",
    d: "M179 601.793h420v2H179z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M338.39 332.043a13.554 13.554 0 0 1 4.38-20.317l-2.83-30.844 18.324-6.291 3.385 43.613a13.628 13.628 0 0 1-23.26 13.839Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M358.061 155.018s12.575-26.39 23.749-17.107-15.32 87.312-15.32 87.312l-4.029 75.748-21.236-2.122-6.004-73.8Z",
    fill: "#ccc"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffb8b8",
    d: "m189.39 545.442 15.764 12.761 56.721-54.731-23.266-18.833-49.219 60.803z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m189.535 537.04 31.045 25.13.002.002a25.455 25.455 0 0 1 3.768 35.799l-.52.643L173 557.468Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#ffb8b8",
    d: "m408.471 580.865 20.282-.001 9.648-78.228-29.933.001.003 78.228z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m403.298 574.243 39.941-.001h.002a25.455 25.455 0 0 1 25.454 25.453v.827l-65.396.003ZM444.06 214.124s38.048 46.32 29.777 92.64-14.889 81.06-14.889 81.06l-13.234 104.221s4.963 28.384-1.655 35.698c0 0 9.926 17.24-8.271 23.857s-28.016-2.286-28.016-2.286-13.341-19.22-5.07-24.183l3.484-204.53-132.519 173.098s-2.436 21.056-19.415 21.281l-20.288 15.114-23.16-13.234 11.58-14.89s-6.617-16.542 8.271-19.85l86.024-112.493 21.506-57.9s11.58-44.666 43.011-62.863V229.5Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M378.715 133.89a31.59 31.59 0 0 1 41.637-5.878l1.374.916a121.937 121.937 0 0 1 28.545 58.77l6.196 33.87-77.752 16.843-18.228-62.864a35.515 35.515 0 0 1 18.228-41.656Z",
    fill: "#ccc"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M506.456 339.244a15.512 15.512 0 0 1-8.849-22.079l-22.429-27.45 13.357-17.699 31.13 39.21a15.596 15.596 0 0 1-13.209 28.018Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M411.8 158.705s-4.962-33.086 11.58-31.432 41.358 92.64 41.358 92.64l44.666 74.444-21.506 11.58-52.937-66.172Z",
    fill: "#ccc"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M442.095 110.335h-78.777a6.119 6.119 0 0 1-6.112-6.112V70.267a45.5 45.5 0 1 1 91 0v33.956a6.119 6.119 0 0 1-6.111 6.112Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 646.056,
    cy: 224.289,
    r: 33.359,
    transform: "rotate(-61.337 404.182 347.535)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M458.97 73.663H416.99l-.43-6.916-2.153 6.916h-6.464l-.854-13.707-4.266 13.707h-12.508v-.68c0-19.846 14.072-35.992 31.369-35.992h5.919c17.297 0 31.369 16.146 31.369 35.993Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M418.726 116.673a10.1 10.1 0 0 1-1.532-.118l-49.97-7.696V56.812a20.047 20.047 0 0 1 20.047-20.047h34.96l-1.362 1.386c-18.947 19.29-4.672 50.57 5.523 67.5a6.671 6.671 0 0 1-.678 7.906 9.078 9.078 0 0 1-6.988 3.116Z",
    fill: "#2f2e41"
  }));
});
var Logic = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Logic = Logic;